<ng-container *ngIf="this.sprint">
  <!-- Start Date -->
  <mat-form-field>
    <input matInput readonly value="{{sprint.startDate | date:'dd.MM.yyyy'}}"
      placeholder="{{'widgets.sprintinfo.start' | translate}}">
  </mat-form-field>

  <!-- Duration -->
  <mat-form-field>
    <input matInput readonly value="{{this.currentSprintDurationAsDays}}"
      placeholder="{{'widgets.sprintinfo.days' | translate}}">
  </mat-form-field>
  
  <!-- End Date -->
  <mat-form-field>
    <input matInput readonly value="{{sprint.endDate | date:'dd.MM.yyyy'}}"
      placeholder="{{'widgets.sprintinfo.end' | translate}}">
  </mat-form-field>
</ng-container>


